module.exports = __webpack_public_path__ + "img/Noctiluca-Inspect-Small.f74db4cf.png";